'use client'
import { Show, createSignal, createEffect } from 'solid-js'
import Accordion from './Accordion'
import Fuse from 'fuse.js'

// Add debounce utility function
function debounce<T extends (...args: any[]) => void>(fn: T, delay: number) {
  let timeoutId: ReturnType<typeof setTimeout>

  return function (...args: Parameters<T>) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn(...args), delay)
  } as T
}

const data = [
  {
    heading: 'What is CosplayFans?',
    para: ` <p>
                  At CosplayFans, transform your fantasies into reality and
                  connect with your favorite creators.
                </p>
                <p>content in various ways.</p>
                <p>You can:</p>
                <p>View free images our creators share.</p>
                <p>Stay updated by following your favorite creators.</p>
                <p>Subscribe to their personal page for exclusive content.</p>
                <p>
                  Purchase tokens and use them for personal content generation.
                </p>
                <p>Express appreciation by sending tips to creators.</p>
                <p>
                  Engage with content through likes and comments on the
                  platform.
                </p>`,
  },
  {
    heading: 'What are tokens?',
    para: `Tokens serve as a form of online currency that you use across CosplayFans to make purchases on the site.`,
  },
  {
    heading: 'What type of content can I find on CosplayFans?',
    para: `On CosplayFans, you can discover a wide variety of adult entertainment content, including live chats, exclusive creator content, and full control over the content of your favorite character. The platform offers interactive experiences with tons of characters, personalized content from characters, and a wide variety of genres, catering to a diverse audience seeking engaging adult entertainment.`,
  },
  {
    heading:
      'I’m worried about what my bank will think. How does the payment look on my statement or bills?',
    para: `On your bank or credit card statement, you’ll see your transactions as Epoch . This ensures complete confidentiality of your purchases.`,
  },
  {
    heading: 'I’ve subscribed to more than one cosplay creator, how will I be billed?',
    para: `Each subscription is a separate transaction. If you have paid for your subscription through your debit or credit card, it will be charged again at the beginning of your subscription period for each creator.`,
  },
  {
    heading: 'My bank declined the payment for my subscription; what should I do next?',
    para: `A card payment can be declined for several reasons. If your card is declined for a payment on CosplayFans you can reach out directly to us as , or you can contact our official payment process at  Epoch.com`,
  },
  {
    heading: "What if I’m not happy with the content I've purchased?",
    para: `When subscribing to a creator you get exclusive free access to the creator’s inbox You can drop them a message and tell them what you want to see more of? Still not happy? You can cancel your subscription at any time.`,
  },
  {
    heading: 'How do I subscribe to a creator?',
    para: `You can go directly to the creators personal page an there you will see a “Subscribe” button. After you click the subscribe button you will be prompted to enter your card details for a successful transactions. After that enjoy your favorite creators content!  `,
  },
  {
    heading: 'How can I cancel a subscription to a creator?',
    para: `
              <p>
                To cancel a subscription, sign into your account and access the
                <span class="text-red">Subscriptions</span> tab.
              </p>
              <p>Here you will find all of your active subscriptions.</p>

              <p>
                Simply find the creator you would like to cancel and then click
                on the next to their name and hit the Cancel Subscription
                option.
              </p>`,
  },
  {
    heading: 'I’ve subscribed to a creator, what happens next?',
    para: `Enjoy your creators content and private photos. At anytime you control the aspect of your character from backgrounds, undressing, change clothes and more!`,
  },
  {
    heading: "How can I express my appreciation for a creator's work?",
    para: `When you love what a creator does, you can send them a tip, subscribe to their exclusive content or let them know through a direct message!`,
  },
  {
    heading: 'How can I contact CosplayFans',
    para: `If you still have questions for us, you can go to our Contact Us page, or email <a href="mailto:support@cosplayfans.ai">support@cosplayfans.ai</a>.`,
  },
]

export default function FAQContent() {
  let fuse: Fuse<any>
  const [searchResults, setSearchResults] = createSignal(data)
  const [expandedItems, setExpandedItems] = createSignal<string[]>([])

  createEffect(() => {
    fuse = new Fuse(data, {
      keys: ['heading', 'para'],
      includeMatches: true,
      includeScore: true,
      minMatchCharLength: 2,
    })
  })

  const handleSearch = debounce((e: Event) => {
    const target = e.target as HTMLInputElement
    const query = target.value

    if (!query?.trim()) {
      setSearchResults(data)
      setExpandedItems([])
      return
    }

    const results = fuse.search(query)
    if (results.length) {
      setSearchResults(results.map((result) => result.item))
      setExpandedItems(results.map((result) => result.item.heading))
    } else {
      setSearchResults([])
      setExpandedItems([])
    }
  }, 300)

  return (
    <div class="faq-component faq">
      <div class="head gray-to-tran-mobile mb-4 rounded-xl p-4 text-xl font-semibold sm:mb-7 sm:text-2xl md:text-[28px]">
        <h2>Frequently Asked Questions</h2>
      </div>

      <div class="content gray-to-tran-mobile w-full rounded-xl px-4 pt-12 sm:p-6 sm:pt-6">
        <Show when={true}>
          <div class="search relative">
            <input
              class="focus:border-red w-full rounded-xl border border-transparent bg-white/10 px-4 py-2 outline-none transition-all duration-300 md:py-4"
              placeholder="Search Here"
              onInput={handleSearch}
            />

            <div class="btn">
              <button class="absolute right-0 top-0 hidden h-full rounded-full bg-primary px-8 py-4 sm:block">
                Search
              </button>

              <button class="absolute right-0 top-0 flex h-[42px] w-[42px] items-center justify-center rounded-full bg-primary sm:hidden">
                <img width={20} height={20} src="/images/icons/search.svg" alt="search" />
              </button>
            </div>
          </div>
        </Show>
        <div class="accordions mt-6 space-y-4">
          {searchResults().map((item) => (
            <Accordion
              heading={item.heading}
              para={item.para}
              isExpanded={expandedItems().includes(item.heading)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
